<template>
  <form
    autocomplete="off"
    class="admin-organizations-form"
    @reset.prevent="handleCancel"
    @submit.prevent="handleSave"
  >
    <fieldset>
      <label>
        <span class="required">Organization</span>

        <input
          :disabled="disabled"
          id="admin-organization-name"
          required
          type="text"
          v-model.trim="name"
        />
      </label>
    </fieldset>

    <footer>
      <button
        :disabled="!isDeleteEnabled"
        id="admin-organization-delete"
        type="button"
        @click="handleDelete"
        v-if="canDelete && organization.id"
      >Delete</button>

      <button
        :disabled="!isSaveEnabled"
        id="admin-organization-save"
        type="submit"
        v-if="canSave"
      >Save</button>

      <button
        :disabled="!isCancelEnabled"
        id="admin-organization-cancel"
        type="reset"
        v-if="canCancel"
      >Cancel</button>
    </footer>
  </form>
</template>

<script>
import {
  deleteOrganization,
  saveOrganization,
} from "../../api/OrganizationAPI";

export default {
  data() {
    return {
      name: undefined,
    };
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    organization: {
      type: Object,
    },
  },

  computed: {
    canCancel() {
      return true;
    },
    canDelete() {
      return this.can("DELETE_ORGANIZATIONS");
    },
    canSave() {
      return this.can({
        permissions: ["CREATE_ORGANIZATIONS", "UPDATE_ORGANIZATIONS"],
        matchAny: true,
      });
    },
    isCancelEnabled() {
      return !this.disabled;
    },
    isDeleteEnabled() {
      return !this.disabled && this.organization?.id;
    },
    isSaveEnabled() {
      return (
        !this.disabled &&
        (this.organization?.id
          ? this.can("UPDATE_ORGANIZATIONS")
          : this.can("CREATE_ORGANIZATIONS"))
      );
    },
  },

  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    async handleDelete() {
      if (!confirm("Are you sure you want to delete this organization?")) {
        return;
      }

      await deleteOrganization(this.organization);
      this.$emit("delete", this.organization);
    },
    async handleSave() {
      try {
        this.$emit(
          "save",
          await saveOrganization({
            ...this.organization,
            name: this.name,
          })
        );
      } catch (e) {
        this.showErrors(e, "An organization");
      }
    },
    isDirty() {
      if (this.disabled) {
        return false;
      }

      return this.name !== this.organization?.name;
    },
  },

  watch: {
    disabled(to, from) {
      !to && from && this.autofocus();
    },
    organization: {
      immediate: true,
      handler(to, from) {
        if (to !== from) {
          this.name = to?.name;
        }

        !this.disabled && this.autofocus();
      },
    },
  },
};
</script>

<style>
.admin-organizations-form {
  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 0.5em;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.admin-organizations-form > footer {
  grid-column: span 2;
  margin: 0;
  padding: 0.5em 0 0 0;
}
</style>